import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { oc } from 'ts-optchain';
import { LoopBackFilter, Vehicle } from '../../../../shared/sdk/models';
import { LoggerService } from '../../../../shared/sdk/services/custom';
import { QrCodePipe } from '../../../../shared/modules/my-common/pipes/qr-code.pipe';
import { CommonService } from '../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseFormComponent } from '../../../../shared/modules/ui/components/abstract/a-base-form.component';
import { ABaseModelPaneWToolbarComponent } from '../../../../shared/modules/ui/components/abstract/a-base-model-pane-w-toolbar.component';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { HelperService } from '../../../consumer/services/helper.service';
import { VehicleFormComponent } from '../vehicle-form/vehicle-form.component';

@Component({
  selector: 'app-vehicle-details-tab-info',
  templateUrl: './vehicle-details-tab-info.component.html',
  styleUrls: ['./vehicle-details-tab-info.component.scss'],
})
export class VehicleDetailsTabInfoComponent
  extends ABaseModelPaneWToolbarComponent<Vehicle>
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  isBiller$: Observable<boolean>;

  constructor(
    public config: ConfigService,
    protected logger: LoggerService,
    protected ui: UiService,
    protected helper: HelperService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
    private common: CommonService,
  ) {
    super(logger, ui, dss);

    this.isBiller$ = this.config.hasAnyRole$(['SU', 'BILLER']);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.caption = 'Vehicle Info';
  }

  ngAfterViewInit(): void {}

  protected get ModelClass(): any {
    return Vehicle;
  }

  protected get FormComponent(): Type<ABaseFormComponent<Vehicle>> {
    return VehicleFormComponent;
  }

  protected get filter(): LoopBackFilter {
    return { include: [{ relation: 'anyNotes', scope: { order: 'updatedAt DESC', include: 'createdBy' } }] };
  }

  protected get observeModels(): any[] {
    return [this.ModelClass];
  }

  async qrPrint() {
    await this.common.printQr(oc(this.model).vin('')).toPromise();
  }
}
